import { render } from "./TendersFindCard.vue?vue&type=template&id=0b41bb65"
import script from "./TendersFindCard.vue?vue&type=script&lang=js"
export * from "./TendersFindCard.vue?vue&type=script&lang=js"

import "./TendersFindCard.vue?vue&type=style&index=0&id=0b41bb65&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__